import { Map } from 'immutable';

import {
	SET_ALERT_OPTIONS
} from './actionDefinitions';

const alertInitialState = new Map();

const alert = (state = alertInitialState, action) => {
	switch(action.type) {
		case SET_ALERT_OPTIONS:
			return state.set('alertConfig', action.payload);

		default:
			return state;
	}
};

export default alert;
